import { Box, CardContent, CardHeader, Chip, Grid, IconButton, Switch, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
 
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Card, Tables } from 'src/shared/components/index';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { Expence } from '../models';
import { I18N, ROLES } from 'src/shared/constants/constants';
import { useSelector, useDispatch } from 'react-redux';
import React, { FC, useState, useEffect } from 'react';
import { selectUserState } from 'src/auth/login/services/userSlice';
import { Title } from '@mui/icons-material';
interface ExpenceManagementTableProps {
  className?: string;
  dataSelectedAsset?: any;
  inputExpenceData: Expence[];
  inputIsAssetSold?: boolean;
}

const ExpenceManagementTable: FC<ExpenceManagementTableProps> = ({
  inputExpenceData,
  dataSelectedAsset,
  inputIsAssetSold = false
}) => {

  const navigate = useNavigate();
  const { t } = useTranslation(I18N.DEFAULT);
  const [addHock, setAddHock] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  useEffect(() => {
    if (inputIsAssetSold && inputExpenceData) {
      let total = 0;  
      inputExpenceData.forEach((expence) => {
total += +expence.amount;
        });
        setAddHock(total);
        setTotal(total + +dataSelectedAsset?.cost || 0)
    }
  }, [inputExpenceData]);
  const tableColumns: GridColDef[] = [
    {
      field: ' ',
      headerName: ' ',
      sortable: false,
      type: 'string',
      flex: 0.1
    },
    {
      field: 'name',
      sortable: true,
      headerName: t('table.name'),
      flex: 2.5,
      valueGetter: (params) => {
        return `${params.row.name || ''}`;
      }
    },
    {
      field: 'description',
      sortable: true,
      headerName: t('table.description'),
      flex: 2.5,
      valueGetter: (params) => {
        const asset = params.row?.asset ? ` [${params.row?.asset?.name} - (${params.row?.asset?.code})]` : '';
        return `${params.row.description || ''}${asset}`;
      }
    },
    {
      field: 'date',
      sortable: true,
      headerName: t('table.date'),
      flex: 2,
      valueGetter: (params) => {
        if (params?.row?.date) {
          const date: Date = new Date(params?.row?.date);
          return `${date.toLocaleDateString('en-GB') || ''}`;
        }
        return '';
      }
    },
    {
      field: 'amount',
      sortable: true,
      headerName: t('table.amount'),
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.amount || ''}`;
      },
    },
    {
      field: 'Payment method',
      sortable: true,
      headerName: t('table.payment-method'),
      flex: 1.8,
      valueGetter: (params) => {
        return `${params.row?.paymentMethod?.name || ''}`;
      },
    },
  ];

  return (
    <>
      <Card className="mb-24">
        <CardContent>
        {inputIsAssetSold ?<>
          {dataSelectedAsset?.soldStatus === 'SOLD' ? <>
          <Chip label={t('car.sold')} color="success" variant="outlined" />
          <br/>
          <Typography variant="h5" component="div">
        Sold cost : {dataSelectedAsset?.soldCost || ''}
      </Typography>
          </> : <> </>}
          <Typography variant="h5" component="div">
        Purchase cost : {dataSelectedAsset?.cost || 0}
      </Typography> <br/>
        <Typography variant="h5" component="div">
        Purchase cost : {dataSelectedAsset?.cost || 0}
      </Typography> <br/>
      <Typography variant="h5" component="div">
        AddHock : {addHock}
      </Typography>
      <br/>
      <Typography variant="h5" component="div">
        total : {total}
      </Typography></> :<></>}
        <Tables
          rows={inputExpenceData}
          columns={tableColumns}
          checkboxSelection={false}
        />
        </CardContent>
      </Card>
    </>
  );
};

ExpenceManagementTable.propTypes = {
  inputExpenceData: PropTypes.array.isRequired
};

ExpenceManagementTable.defaultProps = {
  inputExpenceData: []
};

export default ExpenceManagementTable;
